import api from './default'

export default api('/api/student-programs', 'student programs')
